module.exports = __webpack_public_path__ + "img/sankaku_17_red.80774405.png";